import React, { Component } from 'react';
import BottomMenu from '../../components/bottom-menu';
import { Search, Inbox, Pets, AccountCircleOutlined } from '@material-ui/icons';
import './style.scss';
import { map } from 'lodash';
import BorrowerItem from '../../components/borrower-item';
import axios from 'axios';

export default class PetBorrower extends Component {
    state = {
        search_filter: '',
        borrowers: [
            {
                name: 'Lenny',
                picture: '',
                description: 'I grew up with my faithful dog Bobby, and would love for my children to discover the love of having a dog in their life. We are looking to get our own puppy but wanted to get children used to responsibility of caring for a dog before taking the big step ourselves.',
                availablity: ['Sunday', 'Monday', 'Friday'],
                contact_number: '+27 62 307 5986',
                location: '2m',
                looking_for: ['take care'],
                experiance: ['owned', 'exercise'],
            },
            {
                name: 'Lenny 2',
                picture: '',
                description: 'I grew up with my faithful dog Bobby, and would love for my children to discover the love of having a dog in their life. We are looking to get our own puppy but wanted to get children used to responsibility of caring for a dog before taking the big step ourselves.',
                availablity: ['Sunday', 'Monday', 'Friday'],
                contact_number: '+27 62 307 5986',
                location: '2m',
                looking_for: ['take care'],
                experiance: ['owned', 'exercise'],
            },
            {
                name: 'Lenny 3',
                picture: '',
                description: 'I grew up with my faithful dog Bobby, and would love for my children to discover the love of having a dog in their life. We are looking to get our own puppy but wanted to get children used to responsibility of caring for a dog before taking the big step ourselves.',
                availablity: ['Sunday', 'Monday', 'Friday'],
                contact_number: '+27 62 307 5986',
                location: '2m',
                looking_for: ['take care'],
                experiance: ['owned', 'exercise'],
            }
        ]
    }

    getPicture() {
        axios.get('https://randomuser.me/api/?results=3').then(results => {
            results = results.data.results;
            let borrowers = map(this.state.borrowers, (item, index) => {
                Object.assign(item, { picture: results[index].picture.large })
                return item;
            });
            this.setState({ borrowers })

        }).catch(err => console.log(err))
    }

    handleChange(e) {
        e.preventDefault();
        this.setState({ search_filter: e.target.value })
    }

    getPets() {
        //axios.get('https://mascota-api.herokuapp.com/hello').then(data => console.log(data)).catch(err => console.log(err));
    }

    componentDidMount() {
        this.getPicture();
    }


    render() {
        return (
            <div className='pet-brorrower'>
                <div className="search">
                    <Search /><input type="text" onChange={this.handleChange.bind(this)} placeholder='Search' />
                </div>
                <div className="borrowers-list">
                    {
                        map(this.state.borrowers, (borrower, index) => (
                            <BorrowerItem borrower={borrower} key={index} />
                        ))
                    }
                </div>
                <BottomMenu menu_items={[

                    { path: '/grid-view', link_name: 'My pets', icon: <Pets /> },
                    { path: '/pet-owner', link_name: 'Me', icon: <AccountCircleOutlined /> }
                ]} />
            </div>
        );
    }
}
